import React from "react";
import { Box, Typography, ImageList, ImageListItem } from "@mui/material";
import { PageLayout } from "../../components/PageLayout/PageLayout";
import Seo from "../../components/Seo/Seo";
import { PAGE_SEO } from "../../seo/seoConstants";
import WhatsAppInfoSection from "../../components/WhatsAppInfoSection/WhatsAppInfoSection";
import { IMAGE_LIST_COLS, IMAGE_LIST_GAP, WHATSAPP_INFO } from "../shared/constants";
import { CommonBoxStyles, ServiceImage } from "../shared/styledComponents";
import { resolveAssetUrl } from "../../utils/assets";

// Bucket keys, not URLs (EB-514) — resolved at render time.
const PREFIX = "detalle-pagina-reparacion-de-celulares";

const images = [
  `${PREFIX}/banner_reparacion_de_celulares.png`,
  `${PREFIX}/flujo_reparacion_de_celulares.png`,
  `${PREFIX}/condiciones_de_servicio_de_reparaciones_1.png`,
  `${PREFIX}/condiciones_de_servicio_de_reparaciones_2.png`,
];

export const MobilePhoneRepairing: React.FC = () => {
  return (
    <PageLayout>
      <Seo {...PAGE_SEO["/reparacion-de-celulares"]} />
      <ImageList cols={IMAGE_LIST_COLS} gap={IMAGE_LIST_GAP}>
        {images.map((src, index) => (
          <ImageListItem key={index}>
            <ServiceImage src={resolveAssetUrl(src)} alt={`repair-image-${index}`} loading="lazy" />
          </ImageListItem>
        ))}
      </ImageList>
      <CommonBoxStyles>
        <Box p={2}>
          <Typography variant="body1" fontWeight="bold" mb={1}>
            Importante
          </Typography>
          <Typography>
            <ul>
              <li>Recuerda pedir remisión al entregar tu celular a uno de nuestros técnicos.</li>
              <li>Recuerda reclamar tu celular a tiempo.</li>
              <li>Debes demostrar que el celular te pertenece.</li>
              <li>
                En Entorno BIAI, uno de nuestros principales valores es el respeto a la propiedad
                privada. Por lo tanto,{" "}
                <strong>
                  no recibimos equipos que puedan ser reportados como robados o de procedencia
                  dudosa
                </strong>
                .
              </li>
            </ul>
          </Typography>
        </Box>
      </CommonBoxStyles>
      <WhatsAppInfoSection {...WHATSAPP_INFO.mobileRepair} />
    </PageLayout>
  );
};

export default MobilePhoneRepairing;
